module.exports = __webpack_public_path__ + "img/telemedicina.2a38b8b1.png";